// export const primaryColor = "#1890ff"
// export const primaryColor = "#d46a9a"
export const primaryColor = "#5270c4"